// Animated white jasmine petals drifting down over the hero.
const PETALS = [
  { left: '6%', size: 16, duration: 13, delay: 0, sway: 26, rotate: 220 },
  { left: '14%', size: 11, duration: 17, delay: 3, sway: 40, rotate: -180 },
  { left: '23%', size: 20, duration: 11, delay: 1.5, sway: 18, rotate: 320 },
  { left: '31%', size: 13, duration: 15, delay: 5, sway: 34, rotate: -260 },
  { left: '40%', size: 18, duration: 12, delay: 2.2, sway: 22, rotate: 200 },
  { left: '49%', size: 10, duration: 18, delay: 6.5, sway: 44, rotate: -300 },
  { left: '58%', size: 15, duration: 14, delay: 0.8, sway: 28, rotate: 240 },
  { left: '67%', size: 22, duration: 10, delay: 4, sway: 16, rotate: -200 },
  { left: '76%', size: 12, duration: 16, delay: 2.8, sway: 38, rotate: 280 },
  { left: '85%', size: 17, duration: 13, delay: 5.5, sway: 24, rotate: -240 },
  { left: '92%', size: 13, duration: 15, delay: 1.2, sway: 32, rotate: 300 },
];

export default function FallingPetals() {
  return (
    <div data-testid="falling-petals" className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {PETALS.map((p, i) => (
        <span
          key={i}
          className="petal"
          style={{
            left: p.left,
            width: `${p.size}px`,
            height: `${p.size * 1.25}px`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            '--sway': `${p.sway}px`,
            '--spin': `${p.rotate}deg`,
          }}
        />
      ))}
    </div>
  );
}
